import { connect } from 'react-redux'
import MapView from '../../../components/Sections/Propiedades/Detail/map'
import { addPlacesInfo } from '../../../actions/propiedades'

const mapStateToProps = (state, ownProps) => {
  return {
  	
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
  	addPlacesInfo: value => dispatch(addPlacesInfo(value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MapView)


// WEBPACK FOOTER //
// ./src/containers/Sections/Propiedades/detailMap.js